export default __webpack_public_path__ + "7529c74a352c7085633a156f1dc0739b.wasm";